<template>
<div>
    <cusHeader></cusHeader>
<div>
    <div class="mx-auto w-75 mt-4">
       <b-form-group
      id="fieldset-1"
      description="Búsqueda por: Nombre, HIP, etc"
      label="Introduzca la búsqueda"
      label-for="input-1"
      valid-feedback="Thank you!"
      :invalid-feedback="invalidFeedback"
      :state="state"
    >
      <b-form-input id="input-1" v-model="name" :state="state" trim></b-form-input>

    </b-form-group>
    <div class="mt-3 row">
    <div class="col-6">
    <label for="example-datepicker1">Fecha desde</label>
    <b-form-datepicker id="example-datepicker1" v-model="valueDate1" locale="es" class="mb-2"></b-form-datepicker>
    </div>
    <div class="col-6">
    <label for="example-datepicker2">Fecha hasta</label>
    <b-form-datepicker id="example-datepicker2" v-model="valueDate2" locale="es" class="mb-2"></b-form-datepicker>
    </div>
  </div>
   <b-row align-h="end">
              <b-button variant="info" >Limpiar filtro</b-button>
              <b-button class='ml-2' variant="primary">Buscar</b-button>
            </b-row>
    <br/>
    <h5>Viernes - 4 de Junio de 2021</h5>
    <br/>

  <b-table striped hover :items='prescriptions1' :fields='table.fields' sort-by.sync="emision">
    <template #cell(actions)="row">
      <div class="table-actions-cell">
        <b-icon-x-circle-fill @click="print(row.item)" class="mr-2" alt="Imprimir"></b-icon-x-circle-fill>
        <b-icon-trash-fill @click="sendEmail(row.item)" class="mr-2" alt="Enviar email"></b-icon-trash-fill>
        <b-icon-printer-fill @click="print(row.item)" class="mr-2" alt="Imprimir"></b-icon-printer-fill>
        <b-icon-file-earmark-text @click="sendEmail(row.item)" class="mr-2" alt="Enviar email"></b-icon-file-earmark-text>
        <b-icon-pencil-square @click="sendEmail(row.item)" class="mr-2" alt="Modificar"></b-icon-pencil-square>
        <b-icon-patch-check @click="sendEmail(row.item)" class="mr-2" alt="Firmada"></b-icon-patch-check>
      </div>
    </template>
  </b-table>
    <br/>
    <h5>Miércoles - 2 de Junio de 2021</h5>
    <br/>
  <b-table striped hover :items='prescriptions2' :fields='table.fields' sort-by.sync="emision">
    <template #cell(actions)="row">
      <div class="table-actions-cell">
        <b-icon-x-circle-fill @click="print(row.item)" class="mr-2" alt="Imprimir"></b-icon-x-circle-fill>
        <b-icon-trash-fill @click="sendEmail(row.item)" class="mr-2" alt="Enviar email"></b-icon-trash-fill>
        <b-icon-printer-fill @click="print(row.item)" class="mr-2" alt="Imprimir"></b-icon-printer-fill>
        <b-icon-file-earmark-text @click="sendEmail(row.item)" class="mr-2" alt="Enviar email"></b-icon-file-earmark-text>
        <b-icon-pencil-square @click="sendEmail(row.item)" class="mr-2" alt="Modificar"></b-icon-pencil-square>
        <b-icon-patch-check @click="sendEmail(row.item)" class="mr-2" alt="Firmada"></b-icon-patch-check>
      </div>
    </template>
  </b-table>

    <br/>
    <h5>Martes - 1 de Junio de 2021</h5>
    <br/>
  <b-table striped hover :items='prescriptions3' :fields='table.fields' sort-by.sync="emision">
    <template #cell(actions)="row">
      <div class="table-actions-cell">
        <b-icon-x-circle-fill @click="print(row.item)" class="mr-2" alt="Imprimir"></b-icon-x-circle-fill>
        <b-icon-trash-fill @click="sendEmail(row.item)" class="mr-2" alt="Enviar email"></b-icon-trash-fill>
        <b-icon-printer-fill @click="print(row.item)" class="mr-2" alt="Imprimir"></b-icon-printer-fill>
        <b-icon-file-earmark-text @click="sendEmail(row.item)" class="mr-2" alt="Enviar email"></b-icon-file-earmark-text>
        <b-icon-pencil-square @click="sendEmail(row.item)" class="mr-2" alt="Modificar"></b-icon-pencil-square>
        <b-icon-patch-check @click="sendEmail(row.item)" class="mr-2" alt="Firmada"></b-icon-patch-check>
      </div>
    </template>
  </b-table>

  <b-modal id="modal-alert" title="BootstrapVue">
    <p class="my-4">Hello from modal!</p>
  </b-modal>
</div>
</div>
</div>
</template>

<script>
import { BIcon, BIconPrinterFill, BIconXCircleFill, BIconTrashFill, BIconFileEarmarkText, BIconPatchCheck, BIconPencilSquare, BTable, BButton, BFormDatepicker, BModal } from 'bootstrap-vue'
import cusHeader from '@/components/layouts/professional/customHeader'

export default {
  components: {
    cusHeader,
    BIcon,
    BIconPrinterFill,
    BIconXCircleFill,
    BIconTrashFill,
    BIconFileEarmarkText,
    BIconPatchCheck,
    BIconPencilSquare,
    BTable,
    BButton,
    BFormDatepicker,
    BModal
  },
  data () {
    return {
      show: true,
      valueDate1: '2021-06-01',
      valueDate2: '2021-06-04',
      table: {
        fields: [
          { key: 'hip', label: 'Tratamiento' },
          { key: 'tratamiento', label: 'Receta' },
          { key: 'emision', label: 'Fecha de emisión', sortable: true },
          { key: 'paciente', label: 'Paciente', sortable: true },
          { key: 'dni', label: 'Dni', sortable: true },
          { key: 'activo', label: 'Tratamiento Activo', sortable: true },
          { key: 'actions', label: '' }
        ]
      },
      prescriptions1: [
        {
          hip: '791110',
          tratamiento: '05351172819518824193959458113995',
          emision: '04/06/2021',
          paciente: 'Maria Jose Corchado Rodriguez',
          dni: '28613882L',
          activo: 'Anulada'
        },
        {
          hip: '791111',
          tratamiento: '95837362563478498493948573635284',
          emision: '04/06/2021',
          paciente: 'Maria Jose Corchado Rodriguez',
          dni: '28613882L',
          activo: 'Activo'
        }],
      prescriptions2: [{
        hip: '121296',
        tratamiento: '65831738481874094220703418436560',
        emision: '02/06/2021',
        paciente: 'Paco Velasco Reina',
        dni: '28615460X',
        activo: 'Sustituido'
      },
      {
        hip: '925950',
        tratamiento: '54215396634644988800830310085653',
        emision: '02/06/2021',
        paciente: 'Paco Velasco Reina',
        dni: '28615460X',
        activo: 'Anulada'
      },
      {
        hip: '264872',
        tratamiento: '39663464498880083031005698725698',
        emision: '02/06/2021',
        paciente: 'Paco Velasco Reina',
        dni: '28615460X',
        activo: 'Bloqueada'
      }],
      prescriptions3: [{
        hip: '598451',
        tratamiento: '346534465354553445635454354543645',
        emision: '01/06/2021',
        paciente: 'Antonio Molina Gómez',
        dni: '28456985G',
        activo: 'Activo'
      }]
    }
  },
  methods: {
    print (prescription) {
      this.$bvModal.show('modal-alert')
      /* alert(`Desea realmente anular la receta`) */
    },
    sendEmail (prescription) {
      this.$bvModal.show('modal-1')
    }
  }
}
</script>

<style lang="less">
  .table-actions-cell {
    display: flex;

    * {
      cursor: pointer;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/webapp/professional/PrescriptionList.vue